import { z } from 'zod';

export const createTrainingSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255, 'Title must be less than 255 characters'),
  description: z.string().min(1, 'Description is required'),
  content: z.string().min(1, 'Content is required'),
  duration: z.string().min(1, 'Duration is required'),
  video_url: z.url('Invalid video URL'),
  image_url: z.string().optional(),
  image: z.instanceof(File).optional(),
});

export type CreateTrainingPayload = z.infer<typeof createTrainingSchema>;
